var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Stratus } from '@stratusjs/runtime/stratus';
import { DOMComplete } from '@stratusjs/core/dom';
import '@stratusjs/angularjs/services/model';
import '@stratusjs/angularjs/services/collection';
Stratus.Services.ListTrac = [
    '$provide',
    ($provide) => {
        $provide.factory('ListTrac', ($q, $window) => {
            const eventQueue = [];
            let listTracLoaded = false;
            let listTracPending = false;
            let listTracAccountId = '';
            let LT;
            let eventTypes = {};
            function loadListTrac() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!listTracAccountId) {
                        console.warn('ListTrac Account Id not provided, will not load');
                        return;
                    }
                    if (!listTracPending && !listTracLoaded) {
                        try {
                            listTracPending = true;
                            yield DOMComplete();
                            const jsFile = $window.document.createElement('script');
                            jsFile.type = 'application/javascript';
                            jsFile.async = true;
                            jsFile.src = `https://code.listtrac.com/monitor.ashx?nonjq=1&acct=${listTracAccountId}`;
                            jsFile.onload = () => loadedListTrac();
                            Stratus.Select('head').append(jsFile);
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                });
            }
            function loadedListTrac() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (Object.prototype.hasOwnProperty.call($window, '_LT') &&
                        typeof ($window._LT) !== 'undefined' &&
                        $window._LT !== null) {
                        eventTypes = $window._eventType;
                        LT = $window._LT;
                        listTracLoaded = true;
                        listTracPending = false;
                        processEventQueue();
                    }
                    else {
                        listTracLoaded = false;
                        console.warn('ListTrac failed to load');
                    }
                    listTracPending = false;
                });
            }
            function setAccountId(accountId) {
                listTracAccountId = accountId;
            }
            function track(eventName, mlsId, postalCode, agentId) {
                return __awaiter(this, void 0, void 0, function* () {
                    yield loadListTrac();
                    const promiseFunction = () => {
                        LT._trackEvent(eventTypes[eventName], mlsId, postalCode, agentId);
                        return;
                    };
                    addEventToQueue(promiseFunction);
                });
            }
            function addEventToQueue(event) {
                eventQueue.push(event);
                if (listTracLoaded) {
                    processEventQueue();
                }
            }
            function processEventQueue() {
                if (!listTracLoaded) {
                    console.warn('Cannot processEventQueue as ListTrac not loaded');
                    return;
                }
                while (eventQueue.length > 0) {
                    $q(eventQueue.shift());
                }
            }
            return {
                setAccountId,
                track
            };
        });
    }
];

//# sourceMappingURL=listTrac.js.map
